module.exports = __webpack_public_path__ + "static/DataGrail-0c03b119235e9a8c87a2bc7676dddb56.jpg";